import { useState } from 'react';
/**
 * Custom hook which allows for displaying the Modal component easily.
 *
 * ```js
 * import { Modal } from '@minerva-analytics/pantheon';
 *
 * const { isShowing, toggleModal } = useModal();
 * <Modal isShowing={isShowing} hide={toggleModal} backdropClosesModal>
 *   <p>I'm a modal!</p>
 * </Modal>
 * ```
 *
 * @param {boolean} showByDefault - Boolean if modal should render as visable. Defaults to false
 *
 * @return {object} isShowing - boolean if the modal is currently showing
 *                  toggleModal - function to toggle the modal
 */

var useModal = function useModal(showByDefault) {
  if (showByDefault === void 0) {
    showByDefault = false;
  }

  var _useState = useState(showByDefault),
      isShowing = _useState[0],
      setIsShowing = _useState[1];

  var toggle = function toggle() {
    setIsShowing(!isShowing);
  };

  return {
    isShowing: isShowing,
    toggleModal: toggle
  };
};

export default useModal;